// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1bcbN","dot":"styles_dot__3Hcwe","pulse":"styles_pulse__Eh-O9"};